import { Grid, useMediaQuery } from '@material-ui/core';
import { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import formatters from '../../../../Core/Grid/inputFormatter';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import { Add, Edit } from '@material-ui/icons';
import ReactDOM from 'react-dom';
import AddDriverRate from './addDriverRate';
import DialogComp from '../../../../Core/Modal/dialogModal';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Sales', active: true },
    { name: 'Driver Rates', active: true }
];

const baseColumns = [
    { field: 'action', title: `Action`, width: '5%', filterable: false, sortable: false },
    { field: 'driverRateBodyType', title: `Body Type`, sortable: true },
    {
        field: 'driverRateMinPrice',
        title: `Min Price`,
        filterable: true,
        sortable: true,
        width: '10%',
        renderer: formatters.CurrencyThousandSeparator,
        align: 'right'
    },
    { field: 'driverRateMinDistance', title: `Min Distance`, filterable: true, sortable: true, width: '10%' },
    { field: 'driverRatePencePerMile', title: `Pence Per Mile`, filterable: true, sortable: true, width: '10%' },
    { field: 'driverRateDefaultSelected', title: `Default?`, filterable: true, sortable: true, width: '8%', renderer: formatters.booleanFormatter }
];
const DriverRates = (props) => {
    const [state, setState] = useState({
        showModal: false,
        driverRateObj: {},
        activeSelected: true,
        isReload: null
    });

    const showAddDriverRateModal = () => {
        setState((prev) => ({ ...prev, showModal: true, driverRateObj: {} }));
    };
    const showEditDriverRateModal = (row) => {
        setState((prev) => ({ ...prev, showModal: true, driverRateObj: row }));
    };
    const hideAddDriverRateModal = (res) => {
        setState((prev) => ({ ...prev, showModal: false, driverRateObj: {} }));
        res && setState((prev) => ({ ...prev, isReload: Date.now() }));
    };

    const addButton = () => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="flex-start" style={{ width: '100%' }}>
                <abbr title="Add Driver Rates">
                    <SquareButton
                        style={{
                            backgroundColor: '#183B68',
                            borderRadius: '20%',
                            width: '32px',
                            height: '32px',
                            textAlign: 'center',
                            padding: '0px 0px 0px 0px',
                            marginLeft: '11px'
                        }}
                        onClick={showAddDriverRateModal}
                    >
                        <Add fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const editButton = (row, data) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="flex-start" style={{ width: '100%' }}>
                <abbr title="Edit Driver Rates">
                    <SquareButton
                        style={{
                            backgroundColor: '#183B68',
                            borderRadius: '20%',
                            width: '32px',
                            height: '32px',
                            textAlign: 'left',
                            padding: '0px 0px 0px 0px'
                        }}
                        onClick={() => showEditDriverRateModal(data)}
                    >
                        <Edit fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((k) => k.field === 'action');
        if (actionCol) actionCol.renderer = editButton;
        return tempCols;
    }, []);

    const baseUrl = `DriverRates`;

    return (
        <div>
            <div className="report-screen-container">
                <Grid container justify="space-between">
                    <Grid item>
                        <BreadCrumbs crumbs={crumbs} />
                    </Grid>
                </Grid>
                <Grid item container spacing={1} xs={12}>
                    <Grid item xs={12}>
                        <ReportGijgoGrid
                            dataConverter={(res) => ({
                                records: res?.data?.list,
                                total: res?.data?.total
                            })}
                            columns={columns}
                            getUrl={baseUrl}
                            AddBtn={addButton}
                            isReload={state.isReload}
                        />
                    </Grid>
                    {state.showModal ? (
                        <DialogComp
                            onClose={hideAddDriverRateModal}
                            title={state.driverRateObj.driverRateID ? 'Update Driver Rate' : 'Add Driver Rate'}
                            maxWidth="md"
                        >
                            <AddDriverRate rowID={state.driverRateObj.driverRateID || null} row={state.driverRateObj} onClose={hideAddDriverRateModal} />
                        </DialogComp>
                    ) : null}
                </Grid>
            </div>
        </div>
    );
};

export default DriverRates;
